import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { DocUtils } from '@iupics-util/tools/doc.utils';

@Pipe({
  name: 'docIcon',
  standalone: true,
})
export class DocIconPipe implements PipeTransform {
  transform(value: string | SafeUrl | undefined): string {
    return DocUtils.getFileIcon(`${value}`);
  }
}
